import PinchZoom from '~/vendors/pinch-zoom'

export default class ProductImageFormGrid {
  constructor(component) {
    this.dom = {
      $imageItems: component.querySelectorAll('.js-productImageItem'),
    }
    this.state = {
      imageLoadedClass: 'imageLoaded',
      videoLoadedClass: 'isLoaded',
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype,
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom, state } = this

    if (state.supportsIntersectionObserver) {
      this.observe()
    } else {
      dom.$imageItems.forEach($item => this.loadImage($item))
    }
  }

  observe() {
    const { dom } = this
    const observer = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: '250px',
    })
    dom.$imageItems.forEach($item => observer.observe($item))
  }

  onIntersection(entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return
      }

      this.loadImage(entry.target)
      observer.unobserve(entry.target)
    })
  }

  loadImage(item) {
    const { state } = this
    const image = item.querySelector('.js-productImage')
    const imageSrc = image?.dataset.src
    const video = item.querySelector('.js-bgVideo')
    const videoSrc = video?.querySelector('source')?.dataset.src

    if (imageSrc) {
      const img = new Image()

      img.src = imageSrc
      img.addEventListener('load', () => {
        image.src = imageSrc
        item.classList.add(state.imageLoadedClass)
        this.initPinchZoom(item)
      })
    }

    if (videoSrc) {
      video.addEventListener('loadeddata', () => {
        this.initPinchZoom(item)
      })
    }
  }

  initPinchZoom(item) {
    const img = item.querySelector('.js-productMediaZoom')

    if (!img) {
      return
    }

    return new PinchZoom(img, {
      tapZoomFactor: 2,
      draggableUnzoomed: false,
      maxZoom: 4,
    })

  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductImageFormGrid = this
  }
}
